import dayjs from 'dayjs';
import { currencyFormatter, getInvoiceStatus } from '../../../utils/utils';

export const normalizeInvoiceData = (data) => {
  const dataSource = data.map((item, index) => {
    const { statusLabel, statusColor } = getInvoiceStatus({
      oper_facturado: item.oper_facturado,
      efact_descripcion: item.efact_descripcion,
      oper_fcanc_id: item.oper_fcanc_id
    });
    return {
      key: `${item.oper_id}_${index}`,
      oper_id: item.oper_id,
      oper_clie_id: item.oper_clie_id,
      oper_uuid: item.oper_uuid,
      oper_cates_id_int: item.oper_cates_id_int,
      'Num. Oper.': item.oper_id,
      Folio: item.cfiscal_codbar,
      'Fecha Oper.': dayjs(item.oper_fecha).format('DD-MM-YYYY'),
      Tipo: item.oper_tipo_operacion === 1 ? 'Boletaje' : 'Pensiones',
      Total: currencyFormatter(item.oper_total),
      RFC: item.clie_rfc,
      Origen: item.oper_sistema === null ? '-' : item.oper_sistema === 1 ? 'Internet' : 'Sistema',
      'Fma. Pago': item.forma_pago,
      'Mét. Pago': item.metodo_pago,
      status: item.oper_facturado,
      efact_descripcion: item.efact_descripcion,
      errtim_descripcion: item.errtim_descripcion,
      cates_descripcion_str: item.cates_descripcion_str,
      estado: statusLabel,
      estado_color: statusColor
    };
  });
  const COLUMN_WIDTHS = {
    RFC: 120,
    Folio: 110,
    'Fecha Oper.': 110,
    'Mét. Pago': 70
  };

  const columns = Object.keys(dataSource[0] || {})
    .map((key) => {
      const hiddenColumns = [
        'key',
        'oper_id',
        'efact_descripcion',
        'cates_descripcion_str',
        'errtim_descripcion',
        'status',
        'estado',
        'estado_color',
        'oper_clie_id',
        'oper_uuid',
        'oper_cates_id_int'
      ];
      if (!hiddenColumns.includes(key)) {
        return {
          title: key,
          dataIndex: key,
          key,
          className: 'col-' + key.replaceAll(' ', '_').toLowerCase(),
          ...(COLUMN_WIDTHS[key] ? { width: COLUMN_WIDTHS[key] } : {})
        };
      }
      return null;
    })
    .filter((col) => col !== null);

  return { dataSource, columns };
};
export const normalizeInvoiceDataForExport = (data) => {
  return data.map((item) => {
    const { statusLabel } = getInvoiceStatus({
      oper_facturado: item.oper_facturado,
      efact_descripcion: item.efact_descripcion,
      errtim_descripcion: item.errtim_descripcion,
      oper_fcanc_id: item.oper_fcanc_id
    });
    return {
      'Número de operación': item.oper_id,
      'Fecha de operación': dayjs(item.oper_fecha).format('DD-MM-YYYY'),
      Tipo: item.oper_tipo_operacion === 1 ? 'Boletaje' : 'Pensiones',
      Total: currencyFormatter(item.oper_total),
      RFC: item.clie_rfc,
      Procedencia: item.oper_sistema === null ? '-' : item.oper_sistema === 1 ? 'Internet' : 'Sistema',
      Estado: statusLabel,
      'Descripción del estado': item.errtim_descripcion
    };
  });
};
